import { ReactComponent as TemplateIcon } from "assets/svg/theLeak.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const theLeak: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "The Leak",
  description:
    "Let fans vote on which upcoming song or demo you play a portion of.",
  templateId: "theLeak",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "The Leak",
        },
      },
      ...getContestDefaults(formState),
    },
    surveyQuestions: [
      {
        id: "question_1",
        type: "SingleSelectQuestion",
        actionRequired: true,
      },
    ],
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-livestream-930ddc"
        : "pp-livestream-699e71",
    fields: [
      {
        name: "date",
        type: "text",
        label: "When does your livestream take place?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.date ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
